import { EditButton, useResourceDefinition } from "react-admin";
import { useLocation } from "react-router-dom";

export const MyEditButton = ({ customResourceData, state = {}, ...props }) => {
  const location = useLocation();
  const contextResourceData = useResourceDefinition();
  const resourceData = customResourceData || contextResourceData;

  if (!resourceData.hasEdit) return null;

  state = { redirectTo: location.pathname + location.search, ...state };

  return <EditButton state={state} {...props} />;
};
